export const ELIGIBLE_PROCESSORS = ['HS_PAYMENTS', 'BYO_STRIPE'];